/**
 * Collection Filters - Filter products by collection and sort by metafield
 */
class CollectionFilters {
  constructor() {
    this.filterButtons = document.querySelectorAll('.collection-filter-btn');
    this.productGrid = document.getElementById('product-grid');
    this.filterSection = document.querySelector('.collection-filter-section');
    this.hoverLabel = document.getElementById('collection-filter-hover-label');
    this.products = this.productGrid ? Array.from(this.productGrid.querySelectorAll('li.column[data-collections]')) : [];
    this.currentFilter = 'all';
    
    this.init();
  }

  init() {
    if (!this.productGrid) {
      return;
    }

    // Sort products by metafield on page load
    this.sortByMetafield();

    // Debug: Log sort orders
    console.log('=== SORT ORDER DEBUG ===');
    this.products.forEach(p => {
      const title = p.querySelector('.product-card__title')?.textContent?.trim() || 'Unknown';
      console.log(`${title}: ${p.dataset.sortOrder}`);
    });

    if (!this.filterButtons.length) {
      return;
    }

    this.filterButtons.forEach(btn => {
      // Hover events for label
      btn.addEventListener('mouseenter', () => {
        const label = btn.dataset.label;
        if (this.hoverLabel && label) {
          this.hoverLabel.textContent = label;
          this.hoverLabel.classList.add('visible');
        }
      });

      btn.addEventListener('mouseleave', () => {
        if (this.hoverLabel) {
          this.hoverLabel.classList.remove('visible');
        }
      });

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const collection = btn.dataset.collection;
        
        // Store scroll position before filtering
        const scrollPos = window.scrollY;
        
        // If clicking the already active filter, deselect it (show all)
        if (btn.classList.contains('active')) {
          this.filterByCollection('all');
          btn.classList.remove('active');
        } else {
          this.filterByCollection(collection);
          this.updateActiveButton(btn);
        }
        
        // Restore scroll position to prevent jumping
        window.scrollTo(0, scrollPos);
      });
    });
  }

  sortByMetafield() {
    if (!this.productGrid || !this.products.length) return;

    const sortedProducts = [...this.products].sort((a, b) => {
      const orderA = parseInt(a.dataset.sortOrder) || 9999;
      const orderB = parseInt(b.dataset.sortOrder) || 9999;
      return orderA - orderB;
    });

    // Reorder in DOM
    sortedProducts.forEach(product => {
      this.productGrid.appendChild(product);
    });

    console.log('Products sorted by metafield!');
  }

  filterByCollection(collectionHandle) {
    this.currentFilter = collectionHandle;

    this.products.forEach(product => {
      const productCollections = product.dataset.collections ? product.dataset.collections.split(',') : [];
      
      if (collectionHandle === 'all') {
        product.style.display = '';
        product.classList.remove('hidden');
      } else if (productCollections.includes(collectionHandle)) {
        product.style.display = '';
        product.classList.remove('hidden');
      } else {
        product.style.display = 'none';
        product.classList.add('hidden');
      }
    });

    // Re-sort after filtering
    this.sortByMetafield();
  }

  updateActiveButton(activeBtn) {
    this.filterButtons.forEach(btn => btn.classList.remove('active'));
    activeBtn.classList.add('active');
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new CollectionFilters());
} else {
  new CollectionFilters();
}
